export default "__VITE_PUBLIC_ASSET__284c15fc__"